import { Theme } from '@mui/material';
import { GridEventListener } from '@mui/x-data-grid';

export const tableStyleSx = ({
  loading,
  onRowClick,
  theme,
}: {
  loading: boolean;
  onRowClick: GridEventListener<'rowClick'> | undefined;
  theme: Theme;
}) => ({
  '& .MuiDataGrid-main': {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor:
      onRowClick === undefined ? 'transparent' : theme.palette.action.hover,
    '& .select-btn': {
      opacity: 1,
    },
    cursor: onRowClick === undefined ? 'default' : 'pointer',
  },
  '& .MuiTablePagination-toolbar': {
    width: '100%',
    fontSize: '12px',
    paddingLeft: '16px',
  },
  '& .MuiTablePagination-root': {
    padding: 0,
    width: '100%',
  },
  '& .MuiTablePagination-actions': {
    display: 'flex',
    gap: '8px',
  },
  '& .MuiTablePagination-spacer': {
    flex: 0,
  },
  '& .MuiTablePagination-displayedRows': {
    marginLeft: 'auto',
    fontSize: '12px',
  },
  '& .MuiDataGrid-virtualScrollerContent': {
    height: `${loading ? '500px !important' : ''}`,
  },
  '& .MuiDataGrid-row': {
    width: 'inherit',
  },
  '& .MuiDataGrid-virtualScrollerRenderZone': {
    position: 'relative',
  },
  '& .MuiTablePagination-selectLabel': {
    color: 'text.secondary',
    fontSize: '12px',
  },
  '& .MuiPagination-ul': {
    flexWrap: 'nowrap',
  },
});
